/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

import { reactive } from "vue"

export const navigationState = reactive({
    categories: [],
    items: [],
    structure: [],
    ready: false,
    source: 'unknown',
    rescueMode: false
})